import React, { useState, type FC, useEffect } from 'react';
import { createPortal } from 'react-dom';

import LitePropertyList from './LitePropertyList';
import { ChevronDoubleLeftIcon, ChevronDoubleRightIcon } from '@heroicons/react/20/solid';
import { Tooltip } from 'primereact/tooltip';

interface DecisionMakingPropertySidebarProps {
  isSidebarOpen: boolean;
  setIsSidebarOpen: (isOpen: boolean) => void;
}

const DecisionMakingPropertySidebar: FC<DecisionMakingPropertySidebarProps> = ({
  isSidebarOpen,
  setIsSidebarOpen,
}) => {
  const [ portalContainer, setPortalContainer ] = useState<HTMLElement | null>(null);

  useEffect(() => {
    const container = document.getElementById('portal-container-arrow-icons');
    if (container) {
      setPortalContainer(container);
    }
  }, []);

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  return (
    <div id='DecisionMakingPropertySidebar'>
      {portalContainer &&
      createPortal(
        <>
          {/* Tooltip Component (Must be rendered at top level) */}
          <Tooltip target=".sidebar-toggle-btn" className='text-xs' />

          {!isSidebarOpen ? (
            <div
              id="open-arrow-container"
              className="cursor-pointer pl-2 sidebar-toggle-btn"
              data-pr-tooltip="Toggle to display list sidebar"
              onClick={toggleSidebar}
            >
              <div className="flex flex-row items-center justify-center hover:bg-gray-200 hover:shadow-md rounded-full">
                <ChevronDoubleRightIcon className="w-6 h-6" color='blue' />
              </div>
            </div>
          ) : (
            <div
              id="close-arrow-container"
              className="cursor-pointer pl-2 sidebar-toggle-btn"
              data-pr-tooltip="Toggle to hide list sidebar"
              onClick={toggleSidebar}
            >
              <div className="flex flex-row items-center justify-center hover:bg-gray-200 hover:shadow-md rounded-full">
                <ChevronDoubleLeftIcon className="w-6 h-6" color='blue' />
              </div>
            </div>
          )}
        </>,
        portalContainer
      )}

      <LitePropertyList isSidebarCollapsed={!isSidebarOpen} />
    </div>
  );
};

export default DecisionMakingPropertySidebar;
